import React, { Component } from "react";

class SidebarMenuButton extends Component {
  render() {
    return (
      <div className="sidebar-menu-button">
        <div className="hamburger-wrapper" onClick={this.props.onClick}>
          <span className="glyphicon glyphicon-menu-hamburger" />
        </div>
        <div className="sidebar-menu-button__logo" />
      </div>
    );
  }
}

export default SidebarMenuButton;
